import { env } from "."

export const list = [
    {
        id: 1,
        title: 'Правила игры',
        text: 'Цель игры – в наборе покерной комбинации карт более сильной, чем у дилера. Для игры используется одна стандартная колода из 52-х карт. Игрок делает ставку Анте (Ante) в пределах минимума и максимума стола и получает 5 карт. У дилера тоже 5 карт, одна из них открыта. За столом может играть только один игрок. Игрок может играть на один бокс или два бокса равными ставками. Если игрок, посмотрев свои карты, отказывается от игры, ставка Анте проигрывает. За сумму, равную ставке Анте, игрок может обменять от двух до пяти карт или докупить шестую карту. После этого игрок принимает решение – продолжать игру или нет. Если игрок принял решение играть, то он должен поставить ставку, равную двум Анте. Если игрок принимает решение не играть (Пас) – теряет при этом ставку Анте. После того, как игроки приняли решение, дилер открывает свои карты. Если у дилера есть игра, он сравнивает ее с покерными комбинациями игроков. У дилера есть игра, если в его картах есть комбинация Туз – Король или выше. Если у дилера нет игры – оплачивается только ставка Анте 1:1. Если у игрока комбинация старше, чем у дилера, оплачивается только ставка Бет в соответствии с таблицей выплат. Кроме выигрышной комбинации в картах игрока может быть образована вторая комбинация, которая также оплачивается. Вторая комбинация должна включать в себя хотя бы одну карту, не входящую в основную комбинацию. При комбинации Стрит оплачивается Стрит и Пара, а не два Стрита. Туз-Король и пара не является двумя парами. Если игровая комбинация игрока ниже, чем у дилера, то его ставки Анте и Бет проигрывают.',
        content:
            <div className="content">
                <p><b>ULTIMATE TEXAS HOLDEM</b><br /><br />
                    Цель игры – собрать наиболее сильную 5-ти карточную комбинацию из 7-ми карт.</p>

                <p>Чтобы начать игру, игрок должен поставить ставки ANTE и BLIND, которые должны быть одинаковые. На этом покере можно ставить дополнительную ставку на поле TRIPS, она не обязательная, но даёт возможность получить дополнительный выигрыш.</p>
                <p>Ставку TRIPS можно ставить только тогда, если поставлены первоначальные ставки ANTE и BLIND.</p>
                <p>Минимальная игра – «ПАРА ДВОЕК».</p>

                <p>
                    Одна пара – две карты одного достоинства<br />
                    Две пары – две разных пары карт одного достоинства<br />
                    Тройка – три карты одного достоинства<br />
                    Стрит – пять карт подряд не одной масти<br />
                    Флеш – пять карт одной масти<br />
                    Фулл Хаус – три карты одного достоинства плюс пара<br />
                    Каре – четыре карты одного достоинства<br />
                    Стрит Флеш – пять карт подряд одной масти<br />
                    Рояль Флеш – пять старших карт одной масти от десятки до туза<br />
                </p>

                <p>В случае совпадения комбинаций победитель определяется по старшей карте в покерной комбинации, а далее по следующим старшим картам. В комбинации «стрит» 5-4-3-2-А туз являтся младшей картой.</p>

                <p>При полном совпадении всех карт в комбинации объявляется «Stand off» (ничья).</p>

                Особенность покера – ставки ANTE/BLIND, которые должны быть одинаковыми.
                <br />
                Выигрышные ставки АNТЕ и BЕТ платятся в соотношении 1:1.<br />
                Выигрышная ставка BLIND оплачивается по таблице выплат.
                <br />

                <p><strong>Выплата по BLIND</strong></p>
                <p>
                    • СТЕЙ до тройки<br />
                    • 1:1 для стрита<br />
                    • 3:2 для флэша<br />
                    • 3:1 для фулл хауса<br />
                    • 10:1 для каре<br />
                    • 50:1 для стрит флэша<br />
                    • 400:1 для Рояль флэш
                </p>

                <p><strong>TRIPS</strong> – отдельная ставка на бокс игрока, либо дилера, оплачивается в первую очередь по таблице выплат вне зависимости от игры у дилера.</p>

                <p><strong>Выплата по TRIPS</strong></p>
                <p>
                    • 3:1 для трех одинаковых карт<br />
                    • 4:1 для стрита<br />
                    • 5:1 для флэша<br />
                    • 8:1 для фулл хауса<br />
                    • 40:1 для каре<br />
                    • 100:1 для стрит флэша<br />
                    • 200:1 для Рояль флэш
                </p>

                <br />
                <p>Ставки оплачиваются и забираются в следующем порядке: ВЕТ, ANTE, BLIND.</p>
                <table className="rule-table">
                    <thead>
                        <tr>
                            <th>Старшая<br />комбинация</th>
                            <th>«Игра» у<br />дилера</th>
                            <th>BLIND</th>
                            <th>ANTE</th>
                            <th>ВЕТ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>ИГРОК</td>
                            <td>«Есть игра»</td>
                            <td>Выигрыш</td>
                            <td>Выигрыш</td>
                            <td>Выигрыш</td>
                        </tr>
                        <tr>
                            <td>ИГРОК</td>
                            <td>«Нет игры»</td>
                            <td>Выигрыш</td>
                            <td>Стей</td>
                            <td>Выигрыш</td>
                        </tr>
                        <tr>
                            <td>ДИЛЕР</td>
                            <td>«Есть игра»</td>
                            <td>Проигрыш</td>
                            <td>Проигрыш</td>
                            <td>Проигрыш</td>
                        </tr>
                        <tr>
                            <td>ДИЛЕР</td>
                            <td>«Нет игры»</td>
                            <td>Проигрыш</td>
                            <td>Стей</td>
                            <td>Проигрыш</td>
                        </tr>
                        <tr>
                            <td>ОДИНАКОВАЯ</td>
                            <td>«Есть/нет»</td>
                            <td>Стей</td>
                            <td>Стей</td>
                            <td>Стей</td>
                        </tr>
                    </tbody>
                </table>

                <p></p>
                «Ultimate Texas Holdem» игра на 1 бокс. Гость должен поставить ставку ВЕТ от 1-го до 4-х АНТЕ (Например, анте бокса - 25$, вет может быть от 25$ до 100$). Для участия в игре гости ставят ставку АNТЕ и равную ей ставку BLIND. Дилер раздает по 2 карты лицом вниз гостю и себе по очереди. После этого ждет решения ИГРОКА.
                <br /><br />
                <p><strong>ПРЕФЛОП.</strong></p>
                ИГРОК после просмотра своих карт принимает решения, закрывать бокс на данном этапе (от 1 до 4 анте) или выбрать «чек». Во втором случае ставка анте и блайнд остаются до следующего этапа игры.
                <br /><br />
                <p><strong>ФЛОП.</strong></p>
                Дилер раздает три общие карты на флоп. После этого гости, не принявшие решение ранее, могут поставить ставку на ВЕТ 2-х АНТЕ, либо снова объявить «чек»
                <br /><br />
                <p><strong>ТЕРН, РИВЕР.</strong></p>
                <p>После решения гостей дилер раздает две оставшиеся карты на флоп. ИГРОК, не принявший решение ранее, может закрыть бокс ставкой ВЕТ, равной АНТЕ на этом этапе, либо уйти в пас. ПРИ УХОДЕ В ПАС, СТАВКА ТРИПСА НА ИГРОКА АВТОМАТИЧЕСКИ ПРОИГРЫВАЕТ! В случае «нет игры» у ДИЛЕРА выделяются старшие 5 карт. </p>

                <p>Карты дилера и игрока всегда сравниваются, независимо от того, есть ли у дилера комбинация или нет. Если комбинация игрока сильнее, чем у дилера, то ставки ANTE и BET всегда оплачиваются 1:1, BLIND в соответствии с таблицей выплат.</p>
                <p>Если у дилера нет комбинации, всегда сравниваются пять самых старших карт с картами игрока.</p>
                <p>Если старшая карта дилера сильнее старшей карты игрока, то ставки BET и BLIND проигрывают, но ставка ANTE остается на месте.</p>
                <p>Если пять старших карт дилера и игрока совпадают, то все ставки остаются на месте за исключением ставки TRIPS, которая играет в независимости от комбинации дилера.</p>
                <p>В случае выигрыша ANTE и BET выплачиваются 1: 1</p>
            </div>
    },
    {
        id: 2,
        title: 'Максимальная выплата',
        text: "",
        content:
            <div className="content">
                <p>Максимальная выплата - выигрыш, который может быть выплачен на 1 бокс. Максимальная выплата работает отдельно на TRIPS и на ANTE & BLIND & BET отдельно.</p>
                <p>При этом лимит действует раздельно для двух групп ставок:</p>
                <p>- TRIPS — имеет свой собственный предел максимальной выплаты.</p>
                <p>- ANTE, BLIND и BET — имеют общий отдельный предел, который считается суммарно для этих трёх ставок.</p>
            </div>
    },
    {
        id: 3,
        title: 'Выигрышные руки',
        content:
            <div className="content">
                - Отдельные карты перечислены по убыванию: туз (старший или младший), король, дама, валет, 10, 9, 8, 7, 6, 5, 4, 3 и 2.
                Туз может быть самой старшей картой в стрите из туза, короля, дамы, валета и 10 или самой младшей в стрите из 5, 4, 3, 2 и туза.
                Возможные руки в порядке убывания:
                <br /><br />
                Флеш-рояль - это стрит-флеш из туза, короля, дамы, валета и 10 одной масти. В случае НИЧЬЕЙ игроку возвращается его исходная ставка, а игра заканчивается.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/royalFlash.svg`} alt="chips" />
                <br /><br />
                Стрит-флеш - это рука, в состав которой входит пять последовательных карт одной масти; например: девятка, восьмерка, семерка, шестерка и пятерка, все червовой масти. Два стрит-флеша сравниваются по самой старшей карте в каждом из них. В случае НИЧЬЕЙ игроку возвращается его исходная ставка, а игра заканчивается.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/streetFlash.svg`} alt="chips" />
                <br /><br />
                Каре - это рука, в состав которой входит четыре карты одного ранга и любая другая
                карта. Например, четыре туза в руке - это и есть каре. Четверки из карт более высокого
                ранга старше четверок из карт более низкого ранга.                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/fourofakind.svg`} alt="chips" />
                <br /><br />
                Фулл-хаус - это рука, в состав которой входят три карты
                одинакового ранга и пара из карт другого ранга, например: три
                короля и две шестерки. Из двух рук с фулл-хаусом старшей является та, в состав
                которой входят три карты более высокого ранга.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/fullhouse.svg`} alt="chips" />
                <br /><br />
                Флеш - это рука, в состав которой входят любые пять карт одной масти в любой
                последовательности, например: пять карт трефовой масти. Два флеша сравниваются
                как руки со старшей картой; для определения победителя сравнивается самая старшая
                карта в каждой из рук. Если в обеих руках совпадают карты самого высокого ранга,
                сравнивается вторая самая высокая по рангу карта. И так до тех пор, пока не будет
                определен победитель. В случае НИЧЬЕЙ игроку возвращается ставка Анте и Бет, а игра
                заканчивается.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/flash.svg`} alt="chips" />
                <br /><br />
                Стрит - это рука, в состав которой входят пять последовательных карт как минимум
                двух разных мстей, например: девятка, восьмерка, семерка, шестерка и пятерка двух
                или более мастей. Два стрита сравниваются по самой старшей карте в каждой из рук.
                Два стрита с одинаковыми старшими картами имеют одинаковую ценность,
                поскольку масти в сравнении не участвуют. В случае НИЧЬЕЙ игроку возвращается
                ставка Анте и Бет, а игра заканчивается.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/street.svg`} alt="chips" />
                <br /><br />
                Тройка - это рука, в состав которой входят три карты одного ранга и две неодинаковые
                карты другого ранга. Например, у игрока с тремя королями в руке есть тройка.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/threeofakind.svg`} alt="chips" />
                <br /><br />
                Две пары - это рука, в состав которой входят две карты одного ранга, две карты
                другого ранга (которые соответствуют друг другу, но не первой паре) и любая другая
                отличная от их рангов карта.<br />
                Примером является рука, в состав которой входят два туза и два короля. Для оценки
                двух рук с двумя парами сначала сравнивается самая высокая пара каждой из рук.
                Побеждает рука с самой высокой парой. Если в обеих руках имеется одинаковая по
                величине самая высокая пара, сравнивается вторая пара каждой из рук. Если в обеих
                руках имеются две равные пары, победитель определяется по следующей карте. В
                случае НИЧЬЕЙ игроку возвращается ставка Анте и Бет, а игра заканчивается.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/twopairs.svg`} alt="chips" />
                <br /><br />
                Пара - это рука, в состав которой входят две карты одного ранга (например: два
                короля) и три неодинаковые карты другого ранга.<br />
                Пара - эта самая слабая рука, которая может победить в игре. Пары из карт более
                высокого ранга побеждают пары из карт более низкого ранга. Если в двух руках
                имеется одинаковая пара, сравниваются следующие карты в порядке убывания. В
                случае НИЧЬЕЙ игроку возвращается ставка Анте и Бет, а игра заканчивается.                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/pair.svg`} alt="chips" />
            </div>
    },
    {
        id: 4,
        title: 'Делайте ставки',
        content:
            <div className="content">

                Панель «ЛИМИТЫ СТАВОК» отображает минимальные и максимальные разрешенные лимиты ставок за столом, которые могут время от времени меняться. Откройте «Лимиты ставок», чтобы проверить свои текущие лимиты.
                <br /><br />
                Russian Poker 1 -  1 000 $
                <br /><br />
                Для участия в игре вам потребуется достаточное количество средств, необходимое для покрытия ставок. Ваш текущий БАЛАНС отображается на экране.
                <br /><br />
                Ваши средства - БАЛАНС 100 000 $
                <br /><br />
                В иммерсивном виде ТАЙМЕР показывает оставшееся время для размещения ставок. По истечении этого времени ставки больше не принимаются.
                <br />
                <img className='rule-button-img' src={`${env.mediapoint}/images/rules/choiseTimer.png`} alt="bet-ante" />
                <br /><br />
                Индикатор «ОТОБРАЖЕНИЕ ФИШЕК» позволяет выбирать достоинство каждой фишки, которую захотите разместить в виде ставки. Для выбора доступны только те фишки, номинал которых может быть покрыт вашим текущим балансом.
                <br /><br />
                <img className='rule-img' src={`${env.mediapoint}/images/rules/chips.svg`} alt="chips" />
                <br /><br />
                После выбора фишки сделайте ставку, нажав на соответствующее место для ставки на игровом столе. При каждом нажатии на место для ставок сумма вашей ставки увеличивается на стоимость выбранной фишки или до максимально допустимого лимита для выбранного вами типа ставки. После размещения максимально допустимого лимита ставки дополнительные средства не принимаются, а над вашей ставкой появится сообщение с уведомлением о размещении максимальной ставки.
                <br /><br />
                <img className='rule-img-big widget' src={`/images/rates.png`} alt="bet-ante" />
                <br /><br />
                ПРИМЕЧАНИЕ: Пожалуйста, не сворачивайте окно браузера и не открывайте другие вкладки в своем браузере, пока активно время размещения ставок и ставки размещаются на столе. Такие действия могут быть расцедены как выход из игры, и, следовательно, ваши ставки будут отклонены в этом раунде игры.
                <br /><br />
                Кнопка «ПОВТОРИТЬ» позволяет повторить все ставки из предыдущего раунда игры. Эта кнопка остается активной до тех пор, пока не будет размещена первая фишка.
                <br /><br />
                <img className='rule-button-img' src={`${env.mediapoint}/images/rules/repeat.svg`} alt="btn" />
                <br /><br />
                Кнопка «УДВОИТЬ» (2×) становится доступной после размещения ставки. С каждым щелчком/нажатием все ваши ставки удваиваются вплоть до максимального предела. Обратите внимание, что вам необходимо иметь достаточное количество средств на счете для удвоения ВСЕХ ваших размещенных ставок.
                <br /><br />
                <img className='rule-button-img' src={`${env.mediapoint}/images/rules/double.svg`} alt="btn" />
                <br /><br />
                Кнопка «ОТМЕНА» позволяет удалить последнюю размещенную ставку.
                <br /><br />
                Повторное нажатие кнопки «ОТМЕНА» позволяет отменить ставки по одной в обратном порядке их размещения. Чтобы удалить все свои ставки, удерживайте нажатой кнопку «ОТМЕНА».
                <br /><br />
                <img className='rule-button-img' src={`${env.mediapoint}/images/rules/cancel.svg`} alt="btn" />
                <br /><br />
                Индикатор «ОБЩАЯ СТАВКА» отображает общую сумму ставок, размещенных в текущем раунде.
                <br /><br />
                <img className='rule-img border' src={`${env.mediapoint}/images/rules/totalBet.svg`} alt="total" />
                <br /><br />
                Примите решение
                <br /><br />
                После раздачи ваших карт появится ваша комбинация карт и окно
                <br /><br />
                <img className='rule-img-big widget' src={`/images/ultimate-game.png`} alt="game" />
                <br /><br />
                <img className='rule-img-big widget' src={`/images/ultimate-buttons.png`} alt="game" />
                <br /><br />
                Для CHECK надо нажать окно
                <br /><br />
                <img className='rule-img-big' src={`/images/check.png`} alt="sixth" />
                <br /><br />
                Вы должны решить, что нажать: «BET» для продолжения раунда игры или «ПАС» для завершения раунда игры с потерей размещенных ставок.
                <br /><br />
                <img className='rule-img-big' src={`/images/bet-pass.png`} alt="btn" />
                <br /><br />
                При нажатии на кнопку «BET» вы продолжаете играть и делаете ставку «BET», Ставка «BET» будет автоматически размещена в месте для ставки «BET».
                <br /><br />
                После щелчка/нажатия кнопки «ПАС» вы потеряете свою ставку АНТЕ и BLIND.
                Вы сможете наблюдать за ходом игры, но не сможете в ней участвовать. Чтобы сделать новые ставки, вам придется дождаться следующего раунда.
                <br /><br />
            </div>
    },
    {
        id: 5,
        title: 'Чат',
        content:
            <div className="content">
                Вы можете обмениваться сообщениями с ведущим игры и другими игроками. Введите свое сообщение в окне ЧАТА. Для отправки сообщения нажмите Ввод или стрелочку, расположенную в поле.
                <br /><br />
                Для игроков, которые некорректно ведут себя в чате, оскорбляют ведущего и других игроков, используют неуместные и/или оскорбительные выражения, доступ к чату будет закрыт.
                <br /><br />
                Используйте кнопку «ЧАТ» для увеличения или закрытия окна чата.
                <br /><br />
                <img className='rule-img' src={`${env.mediapoint}/images/control-buttons/chat.svg`} alt="chips" />
            </div>
    },
    {
        id: 6,
        title: 'Номер игры',
        content:
            <div className="content">
                Каждый раунд игры идентифицируется уникальным НОМЕРОМ ИГРЫ.
                <br /><br />
                <img className='rule-img border' src={`${env.mediapoint}/images/rules/game-number.svg`} alt="number" />
                <br /><br />
                Пожалуйста, используйте этот номер (или сделайте снимок экрана с номером игры), если вы хотите обратиться в Службу поддержки с вопросами относительно определенного раунда.
            </div>
    },
    {
        id: 7,
        title: 'Звук',
        content:
            <div className="content">
                Кнопка «ЗВУК» включает/выключает все звуки игры и голоса.
                Примите к сведению, что в случае смены стола все звуки включатся автоматически.
                <br /><br />
                <img className='rule-img' src={`${env.mediapoint}/images/control-buttons/audio-on.svg`} alt="chips" />
                <br /><br />
                Вы можете изменить настройки звука, нажав кнопку «НАСТРОЙКИ» и выбрав вкладку ЗВУК,
            </div>
    },
    {
        id: 8,
        title: 'История игр',
        content:
            <div className="content">
                С помощью кнопки «ИСТОРИЯ» можно открыть окно, в котором будут отображены все сыгранные вами раунды игры и их результаты.
                <br /><br />
                <img className='rule-img' src={`${env.mediapoint}/images/control-buttons/history.svg`} alt="chips" />
                <br /><br />
                Вы можете просматривать свою игровую активность с помощью . следующего:
                <br /><br />
                • ИСТОРИЯ УЧЕТНОЙ ЗАПИСИ - отображает всю историю вашей учетной записи в виде списка дат, игр, сумм ставок и выплат.
                <br /><br />
                Последний завершенный раунд отображается в самом верху списка.
                <br /><br />
                • ИСТОРИЯ ИГР -- после щелчка/нажатия на определенную игру в столбце ИГРА отображает вашу историю, связанную с определенной игрой.
            </div>
    },
    {
        id: 9,
        title: 'Действия в случае сбоя',
        content:
            <div className="content">
                При сбоях в игре, игровой системе или процедуре игры раунд временно
                приостанавливается, а ведущий игры уведомляет об этом сервис-менеджера. Вы и
                другие игроки увидят сообщение в чате или всплывающее сообщение на экране о том,
                что данный вопрос рассматривается. Если менеджер сможет незамедлительно
                устранить ошибку, раунд игры продолжится, как обычно. В случае отсутствия
                возможности незамедлительного устранения раунд игры аннулируется, а изначальные
                ставки подлежат возмещению всем игрокам, принявшим в нем участие.            </div>
    },
    {
        id: 10,
        title: 'Политика отключения',
        content:
            <div className="content">
                В случае отключения от игры до истечения времени для размещения ставок любые
                сделанные ставки признаются недействительными и возвращаются вам. В случае
                отключения после истечения времени для размещения ставок, сделанные ставки
                признаются действительными и разыгрываются без вашего участия. Результаты
                розыгрыша ставки можно посмотреть в окне «История» после повторного
                подключения.
            </div>
    }
]